<template>
  <page-template page-id="error" ref="super">

    <document-title :title="$t('errors.errorPage.' + status + '.title')"></document-title>

    <template v-slot:before v-if="isTitlebarActive">
      <titlebar :text="$t('errors.errorPage.' + status + '.title')"></titlebar>
    </template>

    <div class="ui column">

      <h4 class="custom-ui header" v-text="status"></h4>
      <div class="field">
        <h1 v-text="$t(summary ? 'errors.errorPage.' + summary : 'errors.errorPage.' + status + '.summary')"></h1>
      </div>
      <div v-if="details" class="field">
        <div class="ui left aligned wrapped message" v-text="details">
        </div>
      </div>
      <div class="field">
        <p class="bold" v-text="'Request-ID: ' + requestId"></p>
      </div>
      <div v-if="showBack" class="field">
        <a class="ui fluid primary button" href="javascript:history.back()">Click here to go
          back to the previous page</a>
      </div>

    </div>
  </page-template>
</template>

<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'

/* global errorSummary */
/* global errorStatus */
/* global errorRequestId */
/* global errorShowBack */

export default {
  components: {
    PageTemplate,
    Titlebar
  },
  mixins: [mixin, brand],
  data: function () {
    return {
      status: errorStatus,
      summary: errorSummary,
      details: null,
      requestId: errorRequestId,
      showBack: errorShowBack
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
</style>
